import { Box, Stack, Typography } from '@mui/material';
import { AnimatePresence } from 'motion/react';
import { FC } from 'react';

import { VpFade } from '@vp/common/ui/component/VpFade';
import { ProfileModel } from '@vp/profile/core/model/ProfileModel';
import { ProfileAccess } from '@vp/profile/ui/access/ProfileAccess';
import { useSectionMinHeight } from '@vp/profile/ui/hook/useSectionMinHeight';

export interface ProfileBioProps {
  profile: ProfileModel;
}

export const ProfileBio: FC<ProfileBioProps> = ({ profile }) => {
  const minHeight = useSectionMinHeight();

  return (
    <Box width={1} px={{ mobile: 3, tablet: 7 }} pt={{ mobile: 2, tablet: 3 }} pb={{ mobile: 2, tablet: 4 }} minHeight={minHeight}>
      <AnimatePresence mode="wait">
        <VpFade key={profile.access.canAccessBio().toString()} duration={0.25}>
          {profile.access.canAccessBio() && (
            <Typography width={1} display="inline-block" whiteSpace="pre-wrap" variant="body1Regular" color="text.disabled">
              {profile.bio}
            </Typography>
          )}

          {!profile.access.canAccessBio() && (
            <Stack width={1} alignItems="center" pt={{ tablet: 4, desktop: 16.875 }}>
              <ProfileAccess />
            </Stack>
          )}
        </VpFade>
      </AnimatePresence>
    </Box>
  );
};
